<template>
    <survey-form/>
</template>

<script>
  import SurveyForm from "@/components/surveys/SurveyForm.vue";
  export default {
    name: "HomeView",
    components: {
      SurveyForm
    },
    data: () => ({
    }),
  };
</script>